import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import axios from '../common/axios';
import { Box, Typography, Card, CardContent,Paper } from '@mui/material';
import BulletChart from '../common/bulletChart';
import TileTitle from '../common/tileTitle';

const OverallChart = ({ height, width, criteriaDate, selectedProject }) => {

    const [loading, setLoading] = useState(true);
    const [bulletDataProgress, setBulletDataProgress] = useState({});
    const [bulletDataResource, setBulletDataResource] = useState({});


    useEffect(() => {
        const fetchData = async () => {
          const date = new Date(criteriaDate);
          try {
            if (selectedProject) {
              const response = await axios.get(`/getoveralldata?project=${selectedProject}&date=${date}`);
              if (response.data.success) {
                const resourceData = {
                  ...response.data.resource[0],
                  pvSum: response.data.pvSum
                };
                setBulletDataProgress({
                  target: response.data.progreess[0].cumulativePV/100,
                  actual: response.data.progreess[0].cumulativeEV/100,
                  max:100
                });

                setBulletDataResource({
                    target: resourceData.cumulativePV,
                    actual: resourceData.cumulativeEV,
                    max:resourceData.pvSum
                  });
              } else {
                setBulletDataResource({});
                setBulletDataProgress({});
              }
              setLoading(false);
            }
          } catch (error) {
            setBulletDataResource({});
            setBulletDataProgress({});
            console.error(`데이터 가져오기 중 오류 발생:`, error);
            return []; // 오류 발생 시 빈 배열 반환
          }
        };
        fetchData();
      }, [criteriaDate, selectedProject]);

      return (
        <Box
        className="test"
          sx={{
            padding: '20px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <Box sx={{ display: 'flex',marginBottom: '8px' , height:(height / 2) - 24}}>
            <Paper sx={{ width: '200px', marginRight: '8px', boxShadow:"none", display:'flex', alignContent:'center' }}>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', height:"100%"}}>
                <Typography variant="h6" sx={{fontSize:12 , color:"#393939", fontWeight:600}}>공정률 (차이: {((bulletDataProgress.actual -bulletDataProgress.target)*100).toFixed(2)}%)</Typography>
                <Typography sx={{fontSize:12 ,  color:"#393939"}}>계획: {(bulletDataProgress.target * 100).toFixed(2)}%</Typography>
                <Typography sx={{fontSize:12 ,  color:"#393939"}}>실적: {(bulletDataProgress.actual * 100).toFixed(2)}%</Typography>
                </div>
                {/* <Typography sx={{fontSize:12}}>차이: {((bulletDataProgress.actual -bulletDataProgress.target)*100).toFixed(2)}%</Typography> */}
            </Paper>
            <BulletChart
              divId={"공정률"}
              width={width-240}
              height={(height / 2) - 5}
              maxValue={bulletDataProgress.max}
              targetValue={bulletDataProgress.target * 100}
              actualValue={bulletDataProgress.actual * 100}
              unit="%"
            />
          </Box>
          <Box sx={{ display: 'flex',height:(height / 2) - 24 }}>
          <Paper sx={{ width: '200px', marginRight: '8px', boxShadow:"none", display:'flex', alignContent:'center' }}>
          <div style={{display:'flex', flexDirection:'column', justifyContent:'center', height:"100%"}}>
                <Typography variant="h6" sx={{fontSize:12 ,  color:"#393939", fontWeight:600}}>Resource(MD) {((bulletDataResource.actual/bulletDataResource.target)*100).toFixed(2)}%</Typography>
                <Typography sx={{fontSize:12,  color:"#393939"}}>계획: {parseInt(bulletDataResource.target).toLocaleString()}MD</Typography>
                <Typography sx={{fontSize:12,  color:"#393939"}}>실적: {parseInt(bulletDataResource.actual).toLocaleString()}MD</Typography>
                </div>
            </Paper>
            <BulletChart
              divId={"Resource(MD)"}
              width={width-240}
              height={(height / 2) - 5}
              maxValue={bulletDataResource.max}
              targetValue={bulletDataResource.target}
              actualValue={bulletDataResource.actual}
              unit="MD"
            />
          </Box>
        </Box>
      );
    };
    
    export default OverallChart;